import { TimeMeasure } from "@axl/membership-sdk";
import { useMemo } from "react";

import { useLoc } from "@app/shared/lib/hooks";
import { LocStringCase } from "@app/shared/lib/localization";

export type TimeLocProps = {
  measure: TimeMeasure;
  value: number;
  renderValue?: (value: number) => React.ReactNode;
  short?: boolean;
  case?: LocStringCase;
  className?: string;
};

export const TimeLoc: React.FC<TimeLocProps> = ({
  measure,
  value,
  renderValue,
  short,
  case: _case = "lower",
  className,
}) => {
  const loc = useLoc();

  const timeLoc = useMemo(() => {
    let pluralKeyPrefix = `TimeMeasure.${measure}`;
    if (short === true) {
      pluralKeyPrefix += ".short";

      return loc.word(pluralKeyPrefix, { case: _case, default: measure });
    }

    pluralKeyPrefix += `.plural`;

    return loc.wordPlural(
      value,
      {
        one: `${pluralKeyPrefix}.one`,
        two: `${pluralKeyPrefix}.two`,
        other: `${pluralKeyPrefix}.other`,
      },
      { case: _case, default: { one: measure, two: measure, other: measure } },
    );
  }, [_case, loc, measure, short, value]);

  return (
    <span className={className}>
      {renderValue ? renderValue(value) : value}
      {!short && <>&nbsp;</>}
      {timeLoc}
    </span>
  );
};
